import React from 'react';

const reviews = [
  { name: "Fatima K.", text: "Great service and fast installation!", rating: 5 },
  { name: "Chukwudi E.", text: "Very professional and reliable.", rating: 5 },
];

const Reviews = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold text-abiu-green-dark mb-4">Customer Reviews</h2>
      <div className="space-y-6">
        {reviews.map((review, index) => (
          <div key={index} className="border-b border-gray-200 pb-6 last:border-b-0">
            <div className="flex justify-between items-start mb-2">
              <div className="font-medium text-abiu-green-dark">{review.name}</div>
              <div className="text-yellow-500">{'★'.repeat(review.rating)}</div>
            </div>
            <p className="text-gray-700 mb-2">"{review.text}"</p>
            <div className="text-sm text-gray-500">2 days ago</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews; 